module.exports = __webpack_public_path__ + "static/media/logo.c82278e9.gif";